module.exports = __webpack_public_path__ + "static/media/5.34fcf0c0.png";